export async function getItem(endpoint) {
  const response = await fetch(`/api/${endpoint}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  });
  return response;
}

export async function getItemWithoutHeaders(endpoint) {
  const response = await fetch(`/api/${endpoint}`);
  return response;
}

export async function editItem(endpoint, id, body) {
  const response = await fetch(id !== undefined ? `/api/${endpoint}/${id}` : `/api/${endpoint}`, {
    method: id !== undefined ? 'PUT' : 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },

    body: JSON.stringify(body)
  });
  return response;
}

export async function editItemExtension(endpoint, id, extension, body) {
  const response = await fetch(`/api/${endpoint}/${id}/${extension}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },

    body: JSON.stringify(body)
  });
  return response;
}

export async function createWithQuery(endpoint) {
  const response = await fetch(`/api/${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  });
  return response;
}

export async function createWithURLSearchParams(endpoint, body) {
  const response = await fetch(`/api/${endpoint}`, {
    method: 'POST',

    body: new URLSearchParams(body)
  });
  return response;
}
export async function createTokenClub(groupId) {
  const response = await fetch(`/api/group/token?groupId=${groupId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  });
  return response;
}

export async function deleteItem(endpoint, id) {
  const response = await fetch(`/api/${endpoint}/${id}`, { method: 'DELETE' });
  return response;
}
export async function deleteItemWithBody(endpoint, body) {
  const response = await fetch(`/api/${endpoint}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },

    body: JSON.stringify(body)
  });
  return response;
}

export async function getReports(endpoint, deviceId, groupId, memberId, from, to, download) {
  let query;
  const downloadQuery = download ? '/xlsx?' : '?';
  if (endpoint === 'trips' || endpoint === 'summary' || endpoint === 'vols') {
    query = `/api/reports/${endpoint}${downloadQuery}${
      deviceId !== 0 ? `deviceId=${deviceId}` : null
    }&${groupId !== 0 ? `groupId=${groupId}` : null}&${
      memberId !== 0 ? `membersId=${memberId}` : null
    }&from=${from}&to=${to}`;
  } else if (endpoint === 'events') {
    query = `/api/reports/events${downloadQuery}deviceId=${deviceId}&groupId=${groupId}&type=geofenceEnter&type=geofenceExit&from=${from}&to=${to}`;
  } else if (groupId !== 0) {
    query = `/api/reports/${endpoint}${downloadQuery}${
      deviceId !== 0 ? `deviceId=${deviceId}` : null
    }&${groupId !== 0 ? `groupId=${groupId}` : null}&from=${from}&to=${to}`;
  } else {
    query = `/api/reports/${endpoint}${downloadQuery}${
      deviceId !== 0 ? `deviceId=${deviceId}` : null
    }&from=${from}&to=${to}`;
  }

  if (download) {
    window.location.assign(query);
    return null;
  }

  const response = await fetch(query, {
    headers: {
      'Content-Type': 'application/json',
      Accept: download
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        : 'application/json'
    }
  });
  return response;
}

export async function getReportsDeviceIds(endpoint, deviceIds, from, to, download) {
  let query;
  const downloadQuery = download ? '/xlsx?' : '?';
  if (endpoint === 'trips' || endpoint === 'summary') {
    query = `/api/reports/${endpoint}${downloadQuery}${deviceIds}from=${from}&to=${to}`;
  } else if (endpoint === 'events') {
    query = `/api/reports/events${downloadQuery}${deviceIds}type=geofenceEnter&type=geofenceExit&from=${from}&to=${to}`;
  } else {
    query = `/api/reports/${endpoint}${downloadQuery}${deviceIds}&from=${from}&to=${to}`;
  }

  if (download) {
    window.location.assign(query);
    return null;
  }
  const response = await fetch(query, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  });
  return response;
}

export async function getReportsPositions(deviceId, from, to) {
  const response = await fetch(
    `/api/positions/optimise?deviceId=${deviceId}&from=${from}&to=${to}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }
  );
  return response;
}

export async function downloadPositions(type, deviceId, from, to) {
  window.location.assign(`/api/positions/${type}?deviceId=${deviceId}&from=${from}&to=${to}`);
}

export async function deletePosition(deviceId, startPositionId, endPositionId) {
  const response = await fetch(`/api/positions/${deviceId}/${startPositionId}/${endPositionId}`, {
    method: 'DELETE'
  });
  return response;
}

export async function deleteFlight(deviceId, startTime, endTime) {
  const response = await fetch(`/api/reports/vol/${deviceId}/${startTime}/${endTime}`, {
    method: 'DELETE'
  });
  return response;
}
